module.exports = __webpack_public_path__ + "static/media/Checkpoint®_Kids stacked_green on white.61c7ec34.png";